<script setup>
import { reactive } from 'vue'
import usePurchase from '../../../store/purchase.store'
import { callApi } from '../../../utils'
import { localeDatePicker } from '../../../utils'
import { PurchaseStatuses, deviceNumberRegex } from '../../../app.config'
import { useQuasar } from 'quasar'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const $q = useQuasar()

const data = reactive({
  startTime: null,
  endTime: null,
  deviceNumbers: [],
  amountFrom: null,
  amountTo: null,
  energyFrom: null,
  energyTo: null,
  statuses: new Array(PurchaseStatuses.length).fill(false),
  phoneNumber: null,
})

const { getPurchaseList, loading, pagination } = usePurchase()

function filter () {
  for (const key in data) if (data[key] === '') data[key] = null

  callApi([getPurchaseList], {
    'page-size': parseInt(pagination.value.rowsPerPage),
    'newer-than': data.startTime,
    'older-than': data.endTime,
    'device-numbers': data.deviceNumbers,
    'amount-from': data.amountFrom,
    'amount-to': data.amountTo,
    'energy-from': data.energyFrom,
    'energy-to': data.energyTo,
    statuses: PurchaseStatuses.filter((status, index) => data.statuses[index]),
    'phone-number': data.phoneNumber,
  }, $q, loading, true)
}

function reset () {
  data.startTime = null
  data.endTime = null
  data.deviceNumbers = []
  data.amountFrom = null
  data.amountTo = null
  data.energyFrom = null
  data.energyTo = null
  data.statuses.fill(false)
  data.phoneNumber = null
  callApi([getPurchaseList], { 
    'page-size': parseInt(pagination.value.rowsPerPage) 
  }, $q, loading, true)
}

function newDeviceNumber (value, done) {
  if (!deviceNumberRegex.test(value)) return
  done(value, 'add-unique')
}

</script>

<template lang='pug'>
.purchase-filter
  q-form(
    @submit='filter'
    @reset='reset'
    class="filter"
  )
    .column
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.startTime'
          :label='t("filter.time.start")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.startTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.endTime'
          :label='t("filter.time.end")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.endTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-input(
          outlined
          :label="t('filter.device.numbers')"
          v-model="data.deviceNumbers"
          use-input
          use-chips
          multiple
          hide-dropdown-icon
          input-debounce="0"
          @new-value="newDeviceNumber"
        )
      .col-auto.q-mb-md
        q-input(
          outlined
          :label="t('filter.phoneNumber')"
          v-model="data.phoneNumber"
          use-input
          use-chips
          multiple
          hide-dropdown-icon
          input-debounce="0"
        )
      
      .col-auto.q-mb-md
        .text-center {{ `${t("purchase.amount")} (₮)` }}
        .flex
          q-input(
            outlined
            v-model='data.amountFrom'
            :label='t("filter.min")'
            hide-hint
            hide-bottom-space
            style="width: calc(50%)"
            mask="############"
          )
          q-input(
            outlined
            v-model='data.amountTo'
            :label='t("filter.max")'
            hide-hint
            hide-bottom-space
            style="width: calc(50%)"
            mask="############"
          )
      .col-auto.q-mb-md
        .text-center {{ `${t("purchase.energy")} (${t("values.kw")})` }}
        .flex
          q-input(
            outlined
            v-model='data.energyFrom'
            :label='t("filter.min")'
            hide-hint
            hide-bottom-space
            style="width: calc(50%)"
            mask="############"
          )
          q-input(
            outlined
            v-model='data.energyTo'
            :label='t("filter.max")'
            hide-hint
            hide-bottom-space
            style="width: calc(50%)"
            mask="############"
          )
      .col-auto.q-mb-md
        .text-center {{ t("purchase.status") }}
        div(v-for='(value, key) in PurchaseStatuses' :key='key')
          q-checkbox(
            v-model='data.statuses[key]'
            :label='t(`purchase.statuses.${PurchaseStatuses[key]}`)'
          )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.clear')"
          :loading='loading'
          type="reset"
          flat
        )
      .col-auto
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.search')"
          :loading='loading'
          type="submit"
          outline
          size='auto'
          color='primary'
        )
</template>